import { useEffect, useRef, useState } from "react";
import { MdOutlineDelete } from "react-icons/md";
import { Toast } from "service/toast";
import upload from "../../../assets/images/upload.svg";
import { IoMdEye } from "react-icons/io";


const UploadFile = ({
  handleFile = () => {},
  handledocumentID = () => {},
  setMSMEregistration = () => {},
  handleMsme=()=>{},
  isMsme=false,
  documentID,
  getFileName,
  filelimit,
  entity,
  MSMEregistration,
  btnLabel = "Upload File",
  accept = ".pdf, .xlsx, .docx, .jpg, .jpeg",
  uploadedDocuments,
}) => {
  const fileInputRef = useRef(null);
  const [fileNames, setFileNames] = useState([]);
  const [fileCount, setFileCount] = useState(0);

  useEffect(() => {
    if (getFileName) {
      setFileNames([]);
    }
  }, [entity]);

  useEffect(() => {
    setTimeout(() => {
      setFileNames([]);
      if (getFileName) {
        setFileNames((prevFileNames) => [...prevFileNames, ...getFileName]);
      }
    }, 0);
  }, [getFileName]);

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;
    // const sizeLimit = 24 * 1024 * 1024; // 24 MB in bytes

    let totalSize = 0;
    for (let i = 0; i < selectedFiles.length; i++) {
      totalSize += selectedFiles[i].size;
    }

    // if (totalSize > sizeLimit) {
    //   Toast({
    //     type: "error",
    //     message: `Total size should be less than ${
    //       sizeLimit / (1024 * 1024)
    //     } MB limit`,
    //   });
    //   return;
    // }

    if (fileCount + selectedFiles.length > filelimit) {
      Toast({
        type: "error",
        message: `Only ${filelimit} ${
          filelimit > 1 ? "files" : "file"
        } allowed`,
      });
      return;
    }

    const newFileNames = Array.from(selectedFiles).map((file) => file.name);
    const latestFile = selectedFiles[selectedFiles.length - 1];
    handleFile(latestFile);
  };

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleDelete = (index, fileName, documentID) => {
    handledocumentID(fileName, index, documentID);
    const updatedFileNames = [...fileNames];
    const deletedFile = updatedFileNames.splice(index, 1)[0];
    setFileCount((prevCount) => prevCount - 1);
    setFileNames(updatedFileNames);

    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    handleFile(updatedFileNames);
    // Toast({ type: "success", message: `File '${deletedFile}' removed.` });
  };

  const handleOpenFile = (fileName) => {
    let updatedDocument = uploadedDocuments?.find(x => x?.fileName === fileName)
    let url = updatedDocument?.filePath || updatedDocument?.fileUrl;
    if (!url) {
      return Toast({ type: "error", message: "File not found" });
    }
    window.open(url, "_blank");
  };

  const handleDeletemsme = (msme) => {
    setMSMEregistration({});
    // Toast({ type: "success", message: `File '${"msme"}' removed.` });
  };
  return (
    <div className="d-md-flex d-sm-block  justify-content-between">
      <div
        style={{
          width: "50%",
          height: window?.innerWidth > 600 ? "44px" : "34px",
          borderRadius: "6px",
          border: "1px solid #A0A0A0",
          display: "flex",
          justifyContent: "space-between",
          padding: "12px 0px 12px 12px",
          backgroundColor: "#FFFFFF",
          color: "#A0A0A0",
          boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.12)",
          cursor: "pointer",
          position: "relative",
          flexDirection: "row",
        }}
        className="w-100 w-md-50"
      >
        <input
          type="file"
          style={{ display: "none" }}
          ref={fileInputRef}
          onChange={handleFileChange}
          accept={accept}
          multiple
        />
        <div
          style={{
            position: "absolute",
            top: "0",
            right: "0",
            background: "#367BBF",
            borderRadius: "6px",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "6px 16px",
          }}
          onClick={() => (isMsme ? handleMsme() : btnLabel == "Uploaded" ? null : handleClick())}
        >
          <div>
            <img src={upload} alt="" />
            &nbsp;&nbsp;
            <span
              className="upload_text"
              style={{
                fontSize: window.innerWidth <= 768 ? "12px" : "inherit",
                color: "#F8F9FD",
              }}
            >
              {" "}
              {btnLabel}
            </span>
          </div>
        </div>
      </div>
      <div
        className="d-flex flex-column d-md-block mx-md-5 mt-md-0 mt-3"
        style={{ width: "100%" }}
      >
        <>
          {documentID?.typeName === "MSME Declaration" ? (
            <>
              {MSMEregistration?.fileName ? (
                <div
                  className="text-capitalize"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                  }}
                >
                  <a>
                    {MSMEregistration?.fileName
                      ? MSMEregistration?.fileName.slice(0, 21) + "..."
                      : ""}
                  </a>
                  <span
                    style={{
                      // display: "flex",
                      alignItems: "center",
                      padding: "10px",
                      height: "100%",
                      color: "#fa8072",
                      transition: "color 0.3s ease",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.color = "#ff0000")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.color = "#fa8072")
                    }
                    onClick={() => handleDeletemsme(MSMEregistration)}
                  >
                    <MdOutlineDelete size={25} />
                  </span>
                </div>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}
        </>

        {fileNames.map((fileName, index) => (
          <div
            className="text-capitalize"
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
            }}
          >
            <a href={documentID?.fileUrl}>
              {fileName ? fileName.slice(0, 21) + "..." : ""}
            </a>
            {fileName ? (
              <div className="d-flex align-items-center justify-content-between">
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "10px",
                    height: "100%",
                    color: "black",
                    transition: "color 0.3s ease",
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.color = "black")}
                  onMouseOut={(e) => (e.currentTarget.style.color = "black")}
                  onClick={() => handleOpenFile(fileName)}
                >
                  <IoMdEye size={25} />
                </span>
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "10px",
                    height: "100%",
                    color: "#fa8072",
                    transition: "color 0.3s ease",
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.color = "#ff0000")}
                  onMouseOut={(e) => (e.currentTarget.style.color = "#fa8072")}
                  onClick={() => handleDelete(index, fileName, documentID)}
                >
                  <MdOutlineDelete size={25} />
                </span>
              </div>
            ) : (
              <></>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default UploadFile;
